export const categoryList = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    description: "Sneakers, casual shoes, and athletic footwear finds from top pandabuy spreadsheets",
    popularity: 5,
    updateFrequency: "Daily",
  },
  {
    name: "Hoodies / Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    description: "Cozy hoodies and premium sweaters curated from the best spreadsheet collections",
    popularity: 5,
    updateFrequency: "Weekly",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    description: "Graphic tees, basics, and statement t-shirts sourced from trending spreadsheets",
    popularity: 5,
    updateFrequency: "Weekly",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    description: "Bombers, denim jackets, and outerwear picks from verified pandabuy lists",
    popularity: 4,
    updateFrequency: "Weekly",
  },
  {
    name: "Pants / Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    description: "Cargo pants, jeans, shorts, and bottoms handpicked from community spreadsheets",
    popularity: 4,
    updateFrequency: "Weekly",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    description: "Caps, beanies, and headwear accessories from the most updated spreadsheet finds",
    popularity: 3,
    updateFrequency: "Bi-weekly",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    description: "Matching sets and coordinated outfits discovered through curated spreadsheet databases",
    popularity: 3,
    updateFrequency: "Weekly",
  },
  {
    name: "Underwear / Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    description: "Comfortable basics and underwear essentials from trusted spreadsheet sources",
    popularity: 2,
    updateFrequency: "Monthly",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    description: "Sports jerseys and athletic wear picks from the pandabuy spreadsheet community",
    popularity: 4,
    updateFrequency: "Weekly",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    description: "Watches, sunglasses, jewelry, and fashion accessories from curated spreadsheet lists",
    popularity: 4,
    updateFrequency: "Weekly",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    description: "Backpacks, crossbody bags, and luggage finds from top-rated spreadsheets",
    popularity: 4,
    updateFrequency: "Weekly",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    description: "Designer-inspired belts and accessories sourced from the best pandabuy lists",
    popularity: 2,
    updateFrequency: "Monthly",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    description: "Fragrance finds and perfume discoveries from community-verified spreadsheets",
    popularity: 3,
    updateFrequency: "Monthly",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    description: "Everything else — home goods, tech accessories, and miscellaneous spreadsheet gems",
    popularity: 3,
    updateFrequency: "Weekly",
  },
];

export const featuredCategories = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    description: "Updated daily sneaker and shoe spreadsheet finds",
    icon: "ri-footprint-line",
    badge: "HOT",
  },
  {
    name: "Hoodies / Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    description: "Premium hoodies and sweaters curated weekly",
    icon: "ri-t-shirt-line",
    badge: "NEW",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    description: "Trending t-shirts from verified spreadsheets",
    icon: "ri-t-shirt-line",
    badge: "TRENDING",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    description: "Best outerwear picks this season",
    icon: "ri-shirt-line",
    badge: "VERIFIED",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    description: "Sports jerseys and athletic gear",
    icon: "ri-medal-line",
    badge: "HOT",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    description: "Watches, jewelry, and fashion add-ons",
    icon: "ri-vip-diamond-line",
    badge: "NEW",
  },
];